export default {
    accountTagsViewEntities_vehicles: "Vehicles",
    accountTagsViewEntities_drivers: "Drivers",
    accountTagsViewEntities_landmarks: "Landmarks",
    accountTagsViewEntities_users: "Users",
    accountTagsViewEntities_forms: "Forms",
    accountTagsViewEntities_geofences: "Geofences",
    accountTagsViewEntities_dynamicForms: "Dynamic Forms",
    accountTagsViewEntities_assets: "Assets"
};